export default function IconUserBlack() {
  return (
    <div className="h-6 w-6">
      <svg
        width="100%"
        height="100%"
        preserveAspectRatio="none"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 11C14.2091 11 16 9.20914 16 7C16 4.79086 14.2091 3 12 3C9.79086 3 8 4.79086 8 7C8 9.20914 9.79086 11 12 11Z"
          fill="#323232"
          stroke="#323232"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.9996 14C5.51211 14 5.03247 19.6831 5.00107 20.8079C4.99805 20.9161 5.08571 21 5.19395 21H18.8052C18.9134 21 19.0011 20.9161 18.9981 20.8079C18.9667 19.6831 18.487 14 11.9996 14Z"
          fill="#323232"
          stroke="#323232"
          strokeWidth="2"
        />
      </svg>
    </div>
  );
}
